export default __webpack_public_path__ + "static/media/sort-alphabetical-ascending-selected.2c7d263b.svg";